<template>
  <div>
    <div class="text-xs-center mx-4 my-2" style="color: #777" v-show="!notifications.length">
      Nenhuma notificação
    </div>
    <v-list-tile class="notification-item" v-for="(notification, index) in notifications"
      :key="index" v-bind:class="{ seen: notification.seen, 'is-link': notification.url && notification.url.length }">
      <v-list-tile-content @click="pushTo(notification)">
        <v-list-tile-title class="notification-item-text">
          {{ notification.title }}
        </v-list-tile-title>
        <v-list-tile-sub-title class="notification-item-text">
          {{ notification.message }}
        </v-list-tile-sub-title>
        <v-list-tile-sub-title>{{ notification.created_at | moment('from', 'now') }}</v-list-tile-sub-title>
      </v-list-tile-content>

      <v-list-tile-action>
        <v-btn icon ripple @click="pushTo(notification)"
          v-if="notification.url && notification.url.length">
          <v-icon color="grey lighten-1" small>fal fa-arrow-square-right</v-icon>
        </v-btn>

        <v-btn icon ripple @click="pushTo(notification)"
          v-if="!notification.seen && !(notification.url && notification.url.length)">
          <v-icon color="grey lighten-1" small>fal fa-check-square</v-icon>
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </div>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'
// const currentUser = JSON.parse(localStorage.getItem('currentUser'))

export default {
  data: () => ({}),

  methods: {
    pushTo (notification) {
      EventBus.$emit('appLoading', true)
      notification.seen = true

      // eslint-disable-next-line
      axios.put(`${API.notifications}/${notification._id}`, notification).then(response => {
        if (notification.url && notification.url.length) {
          window.location.href = notification.url
        }
      })
    }
  },

  props: ['notifications']
}
</script>

<style scoped>
.notification-item {
  max-width: 400px;
  padding: 8px 0 10px 0;
  border-bottom: 1px solid rgba(0,0,0, 0.2);
}

.notification-item:last-child {
  border-bottom: 0;
}

.notification-item-text {
  color: #333 !important;
}

.notification-item.seen {
  opacity: 0.5;
}

.notification-item.is-link {
  cursor: pointer;
}

.notification-item.seen:hover,
.notification-item.is-link:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/modules/AppNotificationsList.vue